(function () {
  var SNIPPET_SRC = 'https://lets.shop/productFirstSnippet.js';

  // Destini's widget theme sets the "Find Products" label to the same color as
  // its background, making it unreadable. The widget renders in a shadow root,
  // so page CSS can't reach it — the override must be injected into the root.
  var FIX_STYLE_ID = 'destini-rff-overrides';
  var FIX_CSS =
    'button[title="Find Products"], button[aria-label="Find Products"] {' +
    ' color: #fff !important; -webkit-text-fill-color: #fff !important; }';

  function patchShadowStyles() {
    var pending = false;
    document.querySelectorAll('.destini-locator-class').forEach(function (host) {
      if (!host.shadowRoot) { pending = true; return; }
      if (host.shadowRoot.getElementById(FIX_STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = FIX_STYLE_ID;
      style.textContent = FIX_CSS;
      host.shadowRoot.appendChild(style);
    });
    return pending;
  }

  var patchTimer = null;
  function watchAndPatch() {
    if (patchTimer) return;
    var tries = 0;
    patchTimer = setInterval(function () {
      var pending = patchShadowStyles();
      if (!pending || ++tries > 200) {
        clearInterval(patchTimer);
        patchTimer = null;
      }
    }, 300);
  }

  function init(root) {
    if (!root || root.dataset.destiniInit === '1') return;
    root.dataset.destiniInit = '1';

    var openBtn = root.querySelector('[data-destini-open]');
    var modal = root.querySelector('[data-destini-modal]');
    if (!openBtn || !modal) return;

    // Portal the modal to <body>: the buy-box column is position:sticky, which
    // creates a stacking context that traps the modal beneath the site header
    // (z-index 999) regardless of the modal's own z-index.
    modal.__destiniRoot = root;
    document.body.appendChild(modal);

    function open() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (!window.__destiniSnippetLoaded) {
        window.__destiniSnippetLoaded = true;
        var s = document.createElement('script');
        s.src = SNIPPET_SRC;
        s.charset = 'utf-8';
        document.body.appendChild(s);
      }
      watchAndPatch();
    }

    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    modal.querySelectorAll('[data-destini-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function initAll() {
    document.querySelectorAll('[data-destini-store-locator]').forEach(init);

    // Page-content embeds (e.g. /pages/store-locator) load the widget on page
    // load rather than through our lazy modal — start watching immediately.
    var hasPageEmbed = Array.prototype.some.call(
      document.querySelectorAll('.destini-locator-class'),
      function (el) { return !el.closest('[data-destini-modal]'); }
    );
    if (hasPageEmbed) watchAndPatch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function () {
    // Drop portaled modals whose section was re-rendered out from under them
    // (theme editor), then bind the freshly rendered ones.
    document.querySelectorAll('body > [data-destini-modal]').forEach(function (el) {
      if (el.__destiniRoot && !document.contains(el.__destiniRoot)) el.remove();
    });
    initAll();
  });
})();
